// extracted by mini-css-extract-plugin
export default {"library__title":"Artists_library__title__UUuPj"};